import {useAppSelector} from "./redux";

export const useAccountsForSelect = () => {

    const keys = ['accountMainIban', 'currency', 'number', 'provider']
    const userAccountsList = useAppSelector( state => state.userReducer.accountsList.accounts)

    const filteredAccounts = userAccountsList.filter((obj: any) => obj.status === "Active").map((obj: any) => keys.reduce((acc: any, key: any) => {
        acc[key] = obj[key];
        return acc;
    }, {}));

    filteredAccounts.push({accountMainIban: "ALL", currency: "", number: ""})

    return filteredAccounts
}
